import { render } from "./Testimonial5Content.vue?vue&type=template&id=cdfc9e2e&scoped=true&ts=true"
import script from "./Testimonial5Content.vue?vue&type=script&lang=ts"
export * from "./Testimonial5Content.vue?vue&type=script&lang=ts"

import "./Testimonial5Content.vue?vue&type=style&index=0&id=cdfc9e2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfc9e2e"]])

export default __exports__